import { Component, OnInit } from '@angular/core';
import { MenuService, AutenticacaoService } from '../../services';
import { MenuSistema } from '../../models/menuSistema';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app-sidebar.component.html',
    providers: [
        MenuService,
        AutenticacaoService
    ]
})
export class AppSidebar implements OnInit  {

    menuSistema: MenuSistema;
    public i = 0;

    constructor(
        private menuServ: MenuService,
        private auth: AutenticacaoService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.menuServ.getMenu(this.auth.user.uid)
            .then(menu => {
                this.menuSistema = menu;
            }).catch(err => {
            });
    }

    navegar(linkUrl: string) {
        this.router.navigate([linkUrl], { queryParams: { 'c': this.i++ } });
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar/app-sidebar.component.ts